// # Clinical Rotations Component
import React, { useState, useEffect } from 'react';
import DashboardHeader from '../../../components/DashboardHeader';
import DashboardFooter from '../../../components/DashboardFooter';
import { useNavigate } from 'react-router-dom';
import { auth, db } from '../../../auth/firebase';
import { doc, updateDoc } from 'firebase/firestore';
import cacheManager from '../../../auth/cache_manager';
import { 
  FaBook,
  FaBuilding,
  FaUserMd
} from 'react-icons/fa';
import './rotations.css';

function Rotations() {
  const navigate = useNavigate();
  const [isDarkMode, setIsDarkMode] = useState(false);

  // # Load theme preference from user data on initial render
  useEffect(() => {
    const loadThemePreference = async () => {
      if (auth.currentUser?.uid) {
        // # Try to get from cache first
        const userData = cacheManager.get(`user_${auth.currentUser.uid}`);
        if (userData && userData.themes && userData.themes.gen_theme !== undefined) {
          setIsDarkMode(userData.themes.gen_theme === 'dark');
        }
      }
    };
    
    loadThemePreference();
  }, []);

  // # Handle theme toggle
  const handleThemeToggle = async () => {
    try {
      const newTheme = !isDarkMode;
      setIsDarkMode(newTheme);
      
      // # Update theme in Firebase if user is logged in
      if (auth.currentUser?.uid) {
        // # Update the user document
        await updateDoc(doc(db, 'users', auth.currentUser.uid), {
          'themes.gen_theme': newTheme ? 'dark' : 'light'
        });
        
        // # Update cache manager
        const userData = cacheManager.get(`user_${auth.currentUser.uid}`);
        if (userData) {
          const updatedUserData = {
            ...userData,
            themes: {
              ...(userData.themes || {}),
              gen_theme: newTheme ? 'dark' : 'light'
            }
          };
          cacheManager.set(`user_${auth.currentUser.uid}`, updatedUserData);
        }
      }
    } catch (error) {
      console.error('Error updating theme preference:', error);
    }
  };

  // # Define rotations sections with icons and descriptions
  const rotationSections = [
    {
      title: 'What is USCE?',
      icon: <FaUserMd className="ext_rot_section-icon" />,
      description: 'Complete guide to U.S. Clinical Experience',
      isReady: true,
      onClick: () => navigate('/community/rotations/usce')
    },
    {
      title: 'Resources',
      icon: <FaBook className="ext_rot_section-icon" />,
      description: 'Clinical rotation guides and study materials',
      isReady: false // # Add isReady flag for consistency
    },
    {
      title: 'Agencies',
      icon: <FaBuilding className="ext_rot_section-icon" />,
      description: 'Clinical rotation placement agencies',
      isReady: false
    }
  ];

  return (
    <div className={`ext_rot_page-container ${isDarkMode ? 'ext_rot_dark-mode' : ''}`}>
      <DashboardHeader isDarkMode={isDarkMode} onThemeToggle={handleThemeToggle} />
      
      <main className="ext_rot_main-content">
        <div className="ext_rot_header">
          <h1>Clinical Rotations</h1>
          <p>Resources and agencies for clinical rotations</p>
        </div>

        <div className="ext_rot_sections-grid">
          {rotationSections.map((section, index) => (
            <div 
              key={index}
              className={`ext_rot_section-card ${section.isReady ? 'clickable' : ''}`}
              onClick={() => section.isReady && section.onClick && section.onClick()}
            >
              <div className="ext_rot_icon-container">
                {section.icon}
              </div>
              <h3>{section.title}</h3>
              <p>{section.description}</p>
              {!section.isReady && (
                <div className="ext_rot_coming-soon">Coming Soon</div>
              )}
            </div>
          ))}
        </div>
      </main>

      <DashboardFooter isDarkMode={isDarkMode} />
    </div>
  );
}

export default Rotations;
